// Gizli mod's provider and its switch in the header. The choice is
// remembered per browser so a reload keeps the screen blind; a
// private window that refuses storage keeps it for the tab.

import {useCallback, useEffect, useMemo, useState} from "react";
import type {ReactNode} from "react";
import {BLIND_KEY, BlindCtx, useBlindSwitch} from "./blind-context";
import {Icon} from "./Icon";

const remembered = (): boolean => {
  try {
    return localStorage.getItem(BLIND_KEY) === "1";
  } catch {
    return false;
  }
};

export function BlindProvider({children}: {children: ReactNode}) {
  const [blind, setBlind] = useState<boolean>(remembered);
  const toggle = useCallback(() => setBlind((b) => !b), []);
  useEffect(() => {
    try {
      localStorage.setItem(BLIND_KEY, blind ? "1" : "0");
    } catch {
      // Storage refused: the switch lives as long as the tab.
    }
  }, [blind]);
  const api = useMemo(() => ({blind, toggle}), [blind, toggle]);
  return <BlindCtx.Provider value={api}>{children}</BlindCtx.Provider>;
}

// The eye alone, round (Onur, 15.10.2026: no label); crossed and lit
// while gizli mod is on.
export function BlindToggle() {
  const {blind, toggle} = useBlindSwitch();
  return (
    <button className={blind ? "round blind-toggle on" : "round blind-toggle"} aria-pressed={blind}
      aria-label={blind ? "Rakamlar gizli" : "Rakamları gizle"}
      title={blind ? "Para rakamları gizli — göstermek için tıklayın" :
        "Para rakamlarını gizle — veli masadayken"}
      onClick={toggle}>
      <Icon name={blind ? "eyeOff" : "eye"} />
    </button>
  );
}
